import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05bb43c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "estimation-panel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Добавление строки", -1))
const _hoisted_3 = { class: "flex flex-col fl-1 m-t-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, [
  /*#__PURE__*/_createTextVNode("Бренд "),
  /*#__PURE__*/_createElementVNode("span", { class: "red-text" }, "*")
], -1))
const _hoisted_5 = { class: "flex flex-col m-t-8" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "strategy",
  class: "small-label"
}, "Стратегия", -1))

import { ref, computed, onMounted } from "vue";
import { useAuthStore } from "@/store/auth/login";
import { useEstimationsSettingsStore } from "@/store/analytics/estimation_settings";

import TopListPanel from "@/widgets/panels/TopListEntitiesPanel.vue";
import OverlayPanel from "primevue/overlaypanel";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";

import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'TopListEstimationSettingsPanel',
  props: {
    isFilterEnabled: { type: Boolean },
    isFilterSetted: { type: Boolean }
  },
  emits: ["setCommonFilter", "toggleFilter", "updateTable"],
  setup(__props: any, { emit: __emit }) {

const authStore = useAuthStore();
const store = useEstimationsSettingsStore();
const op = ref();
const isInvalidForm = ref(false);

const setting = ref({
  brand_pk: null as string | null,
  strategy: "",
});


const emit = __emit;

const setCommonFilterParent = (value: string) => {
  emit("setCommonFilter", value);
};

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["system:edit"], ["analytics:edit"]);
});

const toggleFilterParent = () => {
  emit("toggleFilter");
};

const createAction = (event: any) => {
  isInvalidForm.value = false;
  op.value.toggle(event);
};

const items = ref([
  { label: "Аналитика", archive: "both" },
  { label: "Настройка эстимации", archive: "both" },
]);

const addStroke = (event: any) => {
  if (setting.value.brand_pk == null) {
    isInvalidForm.value = true;
    return;
  }
  store
    .createEstimationSettings(setting.value)
    .then(() => {
      emit("updateTable");
      op.value.toggle(event);
    })
    .catch((err) => {
      if (err.response && err.response.status == 409)
        rootGetters.toast.show("warn", "Ошибка", err.response.data.detail);
    });
  // ;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TopListPanel, {
      isFilterEnabled: _ctx.isFilterEnabled,
      isFilterSetted: _ctx.isFilterSetted,
      items: items.value,
      searchPlaceholder: "Поиск по стратегии",
      buttonLabel: "Добавить строку",
      routeCreate: "",
      onSetCommonFilter: setCommonFilterParent,
      onToggleFilter: toggleFilterParent,
      "disabled-archive": true,
      "is-button-disabled": isDenied.value,
      onCreateAction: createAction
    }, null, 8, ["isFilterEnabled", "isFilterSetted", "items", "is-button-disabled"]),
    _createVNode(_unref(OverlayPanel), {
      ref_key: "op",
      ref: op,
      showCloseIcon: "",
      class: "estimation-overlay"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createVNode(CatalogDataSingleInput, {
                selectType: "brand",
                "use-id-only": true,
                isSegmentSetted: false,
                modelValue: setting.value.brand_pk,
                "is-invalid": isInvalidForm.value && setting.value.brand_pk == null,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (setting.value.brand_pk = $event))
              }, null, 8, ["modelValue", "is-invalid"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createVNode(_unref(InputText), {
                id: "strategy",
                placeholder: "Введите значение",
                modelValue: setting.value.strategy,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((setting.value.strategy) = $event)),
                "aria-describedby": "strategy-help"
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_unref(Button), {
              label: "Добавить",
              class: "purple-button m-t-12 large-text",
              onClick: addStroke
            })
          ])
        ])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})